import request from '@/util/request';


/**
 * 获取品牌列表数据
 * @returns {Promise} 返回一个包含品牌列表数据的 Promise
 */

export function getTokenInfo() {
  return request({
    url: '/auth/get-token',
    method: 'get'
  });
}

export default getTokenInfo
